import { Transforms, Editor } from 'slate';
import { isSimpleBlockActive } from 'slate/functions';
import { ReactEditor } from 'slate-react';
import { CustomEditor, CustomElement, StyledParagraphElement } from 'slate/types/slate';
import { isStyledParagraph } from './isStyledParagraph';

export const insertStyledParagraphForImage = (editor: CustomEditor, imageElement: CustomElement, uuid: string) => {
  const imagePath = ReactEditor.findPath(editor, imageElement);

  const [parentMatch] = Editor.nodes(editor, {
    at: imagePath,
    match: isStyledParagraph,
  });
  if (parentMatch) return;

  const block: StyledParagraphElement = { type: 'styled-paragraph', children: [], id: uuid, connected: true };
  Transforms.wrapNodes(editor, block, { at: imagePath });
};

export const insertStyledParagraph = (editor: CustomEditor, uuid: string) => {
  const isActive = isSimpleBlockActive(editor, 'styled-paragraph');

  Transforms.unwrapNodes(editor, {
    match: isStyledParagraph,
    split: true,
  });

  if (!editor.selection) return;

  Transforms.setNodes(
    editor,
    { type: 'paragraph' },
    {
      at: editor.lastSelection ?? undefined,
    }
  );

  if (!isActive) {
    const block: StyledParagraphElement = { type: 'styled-paragraph', children: [], id: uuid, connected: true };
    Transforms.wrapNodes(editor, block);
  }
};
